import { Switch } from 'react-router-dom'
import RouteMiddleware from 'src/components/common/RouteMiddleware'
import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { COLORS } from 'src/utils/Themes/colors'
import LifeQuickQuotes from 'src/components/BuyPolicy/insuranceScreens/life/LifeQuickQuotes'
import LifeQuoteFilter from 'src/components/BuyPolicy/insuranceScreens/life/LifeQuoteFilter'
import LifePriceDetails from 'src/components/BuyPolicy/insuranceScreens/life/LifePriceDetails'
import LifeMemberDetails from 'src/components/BuyPolicy/insuranceScreens/life/LifeMemberDetails'
import LifeTermsAndConditions from 'src/components/BuyPolicy/insuranceScreens/life/LifeTermsAndCondition'
import { LIFE_ROUTES } from 'src/utils/constants/BuyPolicy'
import { getUrlLastRoute } from 'src/utils/commonMethods'

const LifeInsuranceLayout = () => {
  const classes = useStyles()
  const urlLastRoute = getUrlLastRoute()

  const getQuoteCard = () => {
    return (
      urlLastRoute?.includes(LIFE_ROUTES?.memberDetailsForm) ||
      urlLastRoute?.includes(LIFE_ROUTES?.termsAndConditions) ||
      urlLastRoute?.includes(LIFE_ROUTES?.planDetails)
    )
  }

  return (
    <>
      <div className={'component-container'}>
        <div className={'component-element'}>
          <div className={classes.layout}>
            <div className={classes.insuranceDetailsContainer}>
              <Switch>
                <RouteMiddleware
                  title={'Life Member Details'}
                  path='/individual/dashboard/buyPolicy/life/insuranceDetails/member-details'
                  exact
                  component={LifeMemberDetails}
                />
                <RouteMiddleware
                  title={'Terms And Conditions'}
                  path='/individual/dashboard/buyPolicy/life/insuranceDetails/terms-and-conditions'
                  exact
                  component={LifeTermsAndConditions}
                />
                <RouteMiddleware
                  title={'Life Insurance Details'}
                  path='/'
                  component={LifeQuickQuotes}
                />
              </Switch>
            </div>
            <div className={classes.otherDetailsContainer}>
              <LifeQuoteFilter />
              {getQuoteCard() && <LifePriceDetails />}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default LifeInsuranceLayout

const useStyles = makeStyles({
  layout: {
    display: 'flex',
    flexDirection: 'row',
    gap: '20px',
    backgroundColor: COLORS.WHITE,
    minHeight: 'calc(100vh - 500px)',
  },
  insuranceDetailsContainer: {
    width: '70%',
    display: 'flex',
    flexDirection: 'column',
  },
  otherDetailsContainer: {
    width: '30%',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
})
